
jQuery.extend(jQuery.validator.messages, {
	required: "To pole jest wymagane.",
	remote: "Proszę o wypełnienie tego pola.",
	email: "Proszę o podanie prawidłowego adresu email.",
	url: "Proszę o podanie prawidłowego URL.",
	date: "Proszę o podanie prawidłowej daty.",
	dateISO: "Proszę o podanie prawidłowej daty (ISO).",
	number: "Proszę o podanie prawidłowej liczby.",
	digits: "Proszę o podanie samych cyfr.",
	creditcard: "Proszę o podanie prawidłowej karty kredytowej.",
	equalTo: "Proszę o podanie tej samej wartości ponownie.",
	accept: "Proszę o podanie wartości z prawidłowym rozszerzeniem.",
	maxlength: jQuery.validator.format("Proszę o podanie nie więcej niż {0} znaków."),
	minlength: jQuery.validator.format("Proszę o podanie przynajmniej {0} znaków."),
	rangelength: jQuery.validator.format("Proszę o podanie wartości o długości od {0} do {1} znaków."),
	range: jQuery.validator.format("Proszę o podanie wartości z przedziału od {0} do {1}."),
	max: jQuery.validator.format("Proszę o podanie wartości mniejszej bądź równej {0}."),
	min: jQuery.validator.format("Proszę o podanie wartości większej bądź równej {0}.")
});

jQuery.validator.addMethod("email", function(value, element) {
	if (value==''){
		return true;
	}else {
		return app.getParam('emailReg').test(value);
	}
}, "Podaj poprawny adres e-mail");

jQuery.validator.addMethod("birthday", function (value, element) {
	var today=new Date();
	var data=value.split('-');
	var DOB = new Date(data[2]/1,data[1]/1,data[0]/1,0,0,0);
	var max = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
	var rgexp = /(^(((0[1-9]|[12][0-8]|19)[-](0[1-9]|1[012]))|((29|30|31)[-](0[13578]|1[02]))|((29|30)[-](0[4,6,9]|11)))[-](19|[2-9][0-9])\d\d$)|(^29[-]02[-](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;
	if(rgexp.test(value) && DOB < max) {
		return true;
	}
	return false;
 }, "Format daty urodzin jest niepoprawny");

$.fn.extend({
	checkValid: function(value) {
		if(this.length){
			this.each(function(){
				if($(this).hasClass('error')){
					var id=$(this).attr('id');
					$(this).parents('form').validate().element('#'+id);
					if(!$('#'+id).hasClass('error'))$('label.error[for='+id+']').remove();
				}
			});
		}
		return this;
	}
});

$.fn.extend({
	cleanValid: function(value) {
		if(this.length){
			this.each(function(){
				$(this).removeClass('valid error');
			});
		}
		return this;
	}
});
$.fn.extend({
	disabled: function(value){
		if(this.length){
			this.each(function(){
				var $that = $(this);
				if(value && !$that.is(':disabled')){
					$that.prop('disabled', true);
				} else if(!value && $that.is(':disabled')){
					$that.removeAttr('disabled');
				}
			});
		}
	},
	ignore: function(value) {
		var klasa='ignore';
		if(this.length){
			this.each(function(){
				var em=$('label[for='+$(this).attr('id')+'] em');
				var labelError=$('label.error[for='+$(this).attr('id')+']');
				if(value){
					$(this).addClass(klasa).removeClass('error');
					$(this).closest('.validate-target').removeClass('validate-error');
					if(em.length)em.hide();
					labelError.remove();
				}else{
					$(this).removeClass(klasa);
					if(em.length)em.css('display','inline');
				}
			});
		}
		return this;
	}
});
$.fn.extend({
	required: function(value) {
		var $em=$('<em>*</em>');
		if(this.length){
			this.each(function(){
				var $parentBox =  $(this).closest('.validate-target');
				if(value){
					var $i = $parentBox.find('i');
					var $b = $parentBox.find('b');
					var $label = $parentBox.find('label').not($parentBox.find('label').has('em'));
					$b.length ? $b.after($em) : $i.length ? $i.after($em) : $label.length ? $label.append($em) : false;
				}else{
					$parentBox.find('em').remove();
					$parentBox.find('label.error').remove();
				}
			});
		}
		return this;
	}
});
